import uploadsarticlesbestDuiLawyersSacramentoCountyimagesacramentoCountyCourtroomInteriorJpg from "$lib/data/generated/uploads/articles/best-dui-lawyers-sacramento-county/image/sacramento-county-courtroom-interior.jpg";

export const uploads = {
  "uploads/articles/best-dui-lawyers-sacramento-county/image/sacramento-county-courtroom-interior.jpg": uploadsarticlesbestDuiLawyersSacramentoCountyimagesacramentoCountyCourtroomInteriorJpg
};